    <template>
        <div class="col-12 col-md-12 col-lg-4 mt-3 mt-lg-0 pb-3">
            <div v-if="banners[0] != null" class="p-4 mb-3" :style="bannerBackgroundStyle">
                <div class="col-12 col-sm-6">
                    <div class="banner-content" :class="banners[0]?.dark_desktop_banner == 1 ? 'text-light' : 'text-dark'" v-html="banners[0] != null ? banners[0].content : null"></div>
                </div>
            </div>
            <template v-if="showPaypal">
                <div
                    class="bg-navy px-3 py-2 mb-3 rounded d-none d-sm-block"
                    data-pp-style-logo-position="top"
                    data-pp-message
                    data-pp-placement="category"
                    data-pp-style-layout="text"
                    data-pp-style-text-size="16"
                    data-pp-style-text-color="white"
                ></div>
                <div
                    class="bg-navy px-3 py-2 mb-3 rounded d-block d-sm-none"
                    data-pp-style-logo-position="top"
                    data-pp-message
                    data-pp-placement="category"
                    data-pp-style-layout="text"
                    data-pp-style-text-size="12"
                    data-pp-style-text-color="white"
                ></div>
            </template>
            <b class="route-toggle">Choose a fitting method</b>
            <toggle-range-route
                :home-delivery="this.homeDelivery"
                @rangeRouteToggled="filterTyres"
            ></toggle-range-route>
        </div>
        <size-filters
            :formatted-options="formattedOptions"
            :most-popular="sizeOptions?.most_popular || []"
            :size-options="sizeOptions"
        ></size-filters>
        <br>
        <br>
        <brand-tyre-range-tyres
            class="mb-3"
            :tyres="formattedTyres"
            :brand="brandDetails"
            :banners="updatedTyreCardBanners"
            :basket="updatedBasket"
            @modalOpen="openModal()"
            @basketUpdated="basketUpdated"
        ></brand-tyre-range-tyres>
        <teleport to="body">
            <basket-modal :basket="updatedBasket" :modal-open="modalOpen" @closeModal="modalOpen = false" @basketUpdated="basketUpdated"></basket-modal>
            <upsell-modal :current-tyre="currentTyre" :upsold-tyre="upsoldTyre" :upsell-details="upsellDetails" :upsell-modal-open="upsellModalOpen" @closeModal="upsellModalOpen = false"></upsell-modal>
        </teleport>
</template>

<script>
    import url_filters from '@shared/mixins/url_filters';
    import basket from '@shared/mixins/basket';

    export default {
        props: [
            'brandDetails',
            'tyreRange',
            'tyres',
            'homeDeliverySession',
            'basket',
            'sizeOptions',
            'banners',
            'tyreCardBanners',
            'showPaypal',
            'tyreImagePath',
            'brandImagePath',
            'siteName'
        ],
        mixins: [url_filters, basket],
        emits: ['tyresUpdated'],
        data() {
            return {
	            updatedBasket: this.basket,
                modalOpen: false,
                //There are multiple homeDelivery variations within these components, all are required sadly.
                homeDelivery: (this.homeDeliverySession == 1 ? true : false),
                updatedTyres: this.tyres,
                updatedTyreCardBanners: this.tyreCardBanners || [],
                selectedSizes: {
                    width: '',
                    profile: '',
                    diameter: '',
                    speed: ''
                },
                bannerUrl: this.banners[0] != null ? this.banners[0].brand_mobile_image_url : null,
				basketEmptied: false
            }
        },
	    mounted() {
            //removes loading placeholder - fixes CLS issue
            document.querySelector('#loadingPlaceholder').style.display = 'none';
        },
        methods: {
            openModal() {
	        	this.modalOpen = true;
	        },
            basketUpdated: function(data) {
                this.updatedBasket = data;
            },
            tyresUpdated: function(data) {
                this.updatedTyres = data;
            },
            filterTyres: function(data) {
                if(typeof(data) !== 'undefined')
                {
                    this.homeDelivery = data;
                }
                this.getTyreRangeTyres(this.homeDelivery, this.tyreRange.id, this.brandDetails.id, this.selectedSizes);

                //Empty basket products once route has been changed
                if(this.updatedBasket.products) {
                    if(Object.keys(this.updatedBasket.products).length > 0) {
                        this.updatedBasket.products.splice(0);
                        this.emitter.emit('basketEmptied');
                    }
                }
            },
            replaceByDefault(e) {
                e.target.onerror = null;
                e.target.src = this.tyreImagePath + 'coming_soon.png';
            },
        },
        computed: {
            formattedOptions: function() {
                return [
                    { label: 'Width', name: 'width', data: this.sizeOptions.width },
                    { label: 'Profile', name: 'profile', data: this.sizeOptions.profile },
                    { label: 'Rim', name: 'diameter', data: this.sizeOptions.rim },
                    { label: 'Speed', name: 'speed', data: this.sizeOptions.speed },
                    // { label: 'Load', name: 'load', data: this.sizeOptions.load_index },
                ]
            },
            bannerBackgroundStyle() {
                var object = 'background: url(' + (this.bannerUrl) + ') no-repeat; background-size: cover; background-position: center center;';
                
                return object;
            },
            formattedTyres() {
                var vm = this;
                var tyres = this.updatedTyres;

                //This is necessary as the shared tyre component brand/tyre image urls are specific.
                _.forEach(tyres, function(tyre, key) {
                    tyre['brand_image_url'] = vm.brandImagePath + vm.brandDetails.image;
                    tyre['image_url'] = vm.tyreImagePath + tyre.graphic;
                });

                return tyres;
            }
        }
    }
</script>

<style lang="scss" scoped>
    b {
        &.route-toggle {
            font-size: 20px;
        }
    }
    .brand-logo {
        max-width: 200px;
    }
</style>
